import React, { useEffect, useRef, useState } from "react";

export const MoreInfo = () => {
    const productSpecs = useRef(null);
    const [specs, setSpecs] = useState(null);

    useEffect(() => {
        if (productSpecs == null) return;
        productSpecs.current.innerHTML = productModel.Specification;
        const htmlElements = [];
        const children = $("#product-specifications").children();
        var title = "";
        for (var i = 0; i < children.length; i++) {
            const child = children.eq(i);
            if (child.is("ul")) {
                const bullets = [];
                const listItems = child.children();
                for (var j = 0; j < listItems.length; j++) {
                    if (!!listItems.eq(j).text().trim()) {
                        bullets.push(
                            <li key={`bullet-info-${j}`} className="tw-mb-[15px] tw-ml-[22px] tw-indent-[-22px]"
                                dangerouslySetInnerHTML={{ __html: listItems.eq(j).html() }}>
                            </li>);
                    }
                }
                htmlElements.push(
                    <div key={`ul-info-${i}`} className="info-container">
                        {title}
                        <div className="tw-flex tw-flex-col tw-max-w-[470px]">{bullets}</div>
                    </div>
                )
            }
            else {
                const text = child.text().trim();
                if (!text) continue;
                if (text[text.length - 1] === ":") {
                    title = <div key={`header-info-${i}`} className="tw-text-[17px] tw-text-tamarillo-700 tw-mb-[12px]">{text}</div>;
                }
                else htmlElements.push(<div key={`more-info-${i}`} className="tw-mb-[15px] tw-max-w-[470px]" dangerouslySetInnerHTML={{ __html: child.html() }}></div>);
            }
        }
        setSpecs([...htmlElements]);
    }, [productSpecs])

    useEffect(() => {
        if (window.outerWidth >= 576) {
            var maxHeight = 0;
            $(".info-container").each(function () {
                if ($(this).outerHeight() > maxHeight) {
                    maxHeight = $(this).outerHeight();
                }
            })
            $('#product-info').css({ "maxHeight": `${Math.max(maxHeight, 681)}px` });
        }
    }, [specs])

    return (
        <div id="more-info" className="tw-flex tw-gap-[60px] tw-text-[15px] tw-mt-[15px] tw-mb-[28px] md:tw-mb-[70px]" style={specs !== null ? { height: "auto" } : { height: "700px" }}>
            <div id="product-specifications" className="tw-hidden" ref={productSpecs} />
            <div id="product-info" className="tw-flex tw-flex-col tw-gap-x-[70px] tw-flex-wrap">{specs}</div>
        </div>
    );
}